import React from 'react';

import classes from './Citation.css';

const citation = (props) => {
    return (
        <div className={classes.Citation} style={props.style}>
            <p style={{fontStyle: "italic"}}>&ldquo; {props.children} &rdquo;</p>
            <p>– {props.author}</p>
        </div>
    );
}

export default citation;


// WEBPACK FOOTER //
// ./client/src/components/Citation/Citation.js